import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const WA_URL =
  "https://wa.me/971568498289?text=" +
  encodeURIComponent("Hello Cambroo! I'd like to enquire about your mobile accessories.");

export default function WhatsAppButton() {
  const { t } = useLanguage();
  return (
    <motion.a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label={t("wa_tooltip")}
      title={t("wa_tooltip")}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 200, damping: 15 }}
      className="group fixed bottom-6 left-6 z-[60] flex items-center gap-3 rtl:left-auto rtl:right-6"
    >
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 transition-transform duration-200 group-hover:scale-110">
        <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/40" />
        <MessageCircle className="relative h-6 w-6" fill="currentColor" />
      </span>
      <span className="pointer-events-none rounded-md border border-line bg-white px-4 py-2 text-xs font-medium text-brandink opacity-0 shadow-md transition-opacity duration-200 group-hover:opacity-100">
        {t("wa_tooltip")}
      </span>
    </motion.a>
  );
}
